<template>
    <div id="tableList">

        <Head />
        <div class="tablelist">
            <div class="leftNav">
                <decLeftNav ref="LeftNav" />
            </div>
            <div class="Main">
                <el-date-picker v-model="value" type="year" @change="getlist" :default-value="value" value-format="yyyy"
                    :picker-options="pickerOptions" placeholder="请选择" :clearable="false">
                </el-date-picker>
                <el-table :data="tableData" style="width: 100%" v-loading="loading"
                    element-loading-spinner="el-icon-loading" element-loading-text="报告正在生成中，请耐心等待！"
                    element-loading-background="rgba(0, 0, 0, 0.5)">
                    <el-table-column prop="Title" min-width="35%" header-align="center" align="center"
                        label="申报标题"></el-table-column>
                    <el-table-column prop="jbxx" min-width="10%" header-align="center" align="center" label="申报表"
                        :width="flexColumnWidth('申报表       ')">
                        <template slot-scope="scope">
                            <span @mouseover="bianse(scope.$index, scope)" @mouseout="hy(scope.$index)"
                                style="text-decoration: underline" :class="scope.$index === i ? 'active' : ''"
                                @click="preview(scope.$index, scope.row.jbxx)">
                                <!-- {{scope.row.jbxx}} -->
                                预览
                            </span>
                            <span @mouseover="bianse(scope.$index, '申报表')" style="
                  display: inline-block;
                  margin-left: 0.1rem;
                  background: #409eff;
                  color: #fff;
                  font-size: 0.13rem;
                  padding: 0 0.1rem;
                  border-radius: 0.05rem;
                  cursor: pointer;
                " @mouseout="hy(scope.$index, '申报表')" :class="scope.$index === j ? 'active' : ''"
                                @click="preview(scope.$index, scope.row.jbxx, 1)" v-if="scope.row.cgzbg">下载</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="zbg" min-width="12%" header-align="center" align="center" label="主报告"
                        :width="flexColumnWidth('主报告    ')">
                        <template slot-scope="scope">
                            <span @mouseover="bianse(scope.$index, '预览')" style="text-decoration: underline"
                                @mouseout="hy(scope.$index, '预览')" :class="scope.$index === ylW ? 'active' : ''"
                                @click="ylWord(scope.row.zbg, scope.row.id, 0)">预览</span>
                            <span @mouseover="bianse(scope.$index, '主报告')" style="
                  display: inline-block;
                  margin-left: 0.1rem;
                  background: #409eff;
                  color: #fff;
                  font-size: 0.13rem;
                  padding: 0 0.1rem;
                  border-radius: 0.05rem;
                " @mouseout="hy(scope.$index, '主报告')" :class="scope.$index === j ? 'active' : ''"
                                @click="ylWord(scope.row.zbg, scope.row.id, 1)" v-if="scope.row.cgzbg">下载</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fj" width="50" header-align="center" align="center" label="附件">
                        <template slot-scope="scope">
                            <span :class="scope.$index === a ? 'active' : ''">{{ scope.row.fj }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="zt" min-width="6%" header-align="center" align="center" label="报告状态"
                        :width="flexColumnWidth('报告生成中')">
                        <!-- <template v-if="status">
            <span>{{status}}</span>
            </template>-->
                        <!-- <template slot-scope="scope" v-else>
            <span>{{scope.row.zt}}</span>
            </template>-->
                    </el-table-column>
                    <el-table-column label="成果进度" width="80" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="getJd(scope.row.id)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="DeclarTime" min-width="10%" header-align="center" align="center" label="申报时间"
                        :width="flexColumnWidth('申报时间    ')"></el-table-column>
                    <el-table-column min-width="20%" header-align="center" align="center" label="操作">
                        <template slot-scope="scope" v-if="(scope.row.Status == 0 && scope.row.cgzbgStatus == 0) ||
                            (scope.row.Status == 0 && scope.row.cgzbgStatus == 2)
                            ">
                            <div class="btns">
                                <el-button type="primary" size="mini" @click="submit(scope.$index, scope)">提交</el-button>
                                <el-button type="success" size="mini"
                                    @click="modification(scope.$index, scope.row.id)">修改</el-button>
                                <el-button type="danger" size="mini" @click="delRepot(scope.row.id)"
                                    class="changedel">删除</el-button>
                                <!-- <div class="btn" @click="submit(scope.$index,scope)">提交</div>
                <div class="btn" @click="modification(scope.$index,scope.row.id)">修改</div>
                <div class="btn" @click="delRepot(scope.row.id)">删除</div>-->
                            </div>
                            <el-dropdown>
                                <el-button type="primary" style="padding: 0 5px; height: 30px">
                                    选择操作
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <template>
                                            <span @click="submit(scope.$index, scope)">提交</span>
                                        </template>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <template>
                                            <span @click="modification(scope.$index, scope.row.id)">修改</span>
                                        </template>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <template>
                                            <span @click="delRepot(scope.row.id)">删除</span>
                                        </template>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="preview" v-if="show">
                    <div class="in">
                        <img src="../../assets/back/cha1.png" @click="showP(0)" />
                        <Preview :yulan="yulan" class="preview1" :sbbYear="sbbYear" />
                    </div>
                </div>
                <div class="preview" v-if="showReport">
                    <div class="in">
                        <img src="../../assets/back/cha1.png" @click="showP" />
                        <FullPreview class="FullPreview" :zbg="zbg" />
                    </div>
                </div>
                <!-- <div class="ylW" v-show="ylW">
          <iframe frameborder="0" width="100%" height="90%" name="hrong" class="iframe"></iframe>
          <img src="../../assets/back/x.png" @click="cancelW" />
        </div>-->
            </div>
            <el-dialog v-if="jindu.length > 0" title="成果进度" :visible.sync="dialogVisible" :destroy-on-close="true" center
                top="20vh" width="70%" style="font-size: 0.2rem">
                <el-steps v-if="jindu.length > 0" :active="active" direction="vertical" align-center>
                    <el-step :title="item.zt" v-for="(item, i) in jindu" :key="i">
                        <template slot="description">
                            <div class="content">
                                <div>
                                    <span>{{ item.datetime }}</span>
                                    <div>{{ item.companyName }}</div>
                                    <div v-if="item.comment" class="contentMsg">
                                        <p style="font-weight: 700; height: 0.3rem">审核意见：</p>
                                        <div class="opinion">{{ item.comment }}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-step>
                    <el-step :title="end.zt" v-if="end.time">
                        <template slot="description">
                            <span>{{ end.time }}</span>
                            <p>{{ end.nextcompanyName }}</p>
                        </template>
                    </el-step>
                </el-steps>
            </el-dialog>
        </div>
        <RightNav />
        <Foot />
    </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
import decLeftNav from "../../components/decLeftNav";
import Preview from "./Preview";
import FullPreview from "./FullPreview";
import RightNav from "../../components/RightNav";
export default {
    name: "tableList",
    data() {
        return {
            i: false,
            j: false,
            a: false,
            ylW: false,
            word: "",
            tableData: [],
            zbg: "",
            yulan: "",
            sbbYear: "", //申报表年份
            show: false,
            ReportID: "",
            showReport: false,
            loading: false,
            dialogVisible: false,
            showIdea: false,
            jindu: [],
            useRsubmit: {
                time: "",
                zt: "",
                comment: "",
            },
            end: {
                time: "",
                nextcompanyName: "",
                zt: "",
            },
            active: "",
            accomplish: "",
            value: new Date().getFullYear().toString(),//element组件默认值为String，传数字会读取不出来
            pickerOptions: {
                // 禁选今日之后的时间,time是当前时间选择器的显示内容
                disabledDate(time) {
                    const date = new Date(); //获取当前时间信息
                    const year = date.getFullYear(); //获取当前年份
                    const timeYear = time.getFullYear(); //获取时间选择器的所有年份
                    // 2020之前与今年之后的全部禁用
                    return timeYear < 2020 ? timeYear < 2020 : timeYear > year;
                },
            },
        };
    },
    inject: ["reload"],
    created() {
        window.scrollTo(0, this.$route.query.top || sessionStorage.getItem("scroll"));
    },
    mounted() {
        if (sessionStorage.getItem("isListGo") == "true") {
            this.ReportID = sessionStorage.getItem("reportID");
        } else {
            this.ReportID = sessionStorage.getItem("ReportID");
        }
        if (!sessionStorage.getItem("name")) {
            this.$router.replace("/Declare");
            return;
        }
        this.$refs.LeftNav.isTable();
        this.getlist();
    },
    // destroyed() {
    //   clearInterval(this.timer);
    // },
    methods: {
        // 查看审核意见

        // 查看审核意见
        getlist() {
            let that = this;
            that.$axios
                .post(
                    "reportcontent/contentstatus?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        year: this.value,
                    })
                )
                .then(function (res) {
                    console.log(res.data.data, "table");
                    that.tableData = res.data.data;
                    that.tableData.forEach((val) => {
                        if (val.fj1) {
                            val.fj = "有";
                        } else {
                            val.fj = "无";
                        }
                        // if(val.zbg == "0%"){
                        //   val.zbg='无'
                        // }else{
                        //   val.zbg='有'
                        // }
                        if (val.SuperiorD !== '1') {
                            if (val.Status >= 2) {
                                val.zt = "待审核";
                            }
                            if (val.Status == 0 && val.ccstatus == 2) {
                                val.zt = "查重失败";
                            }
                            if (val.Status == 0 && val.cgzbgStatus == 1 && val.ccstatus_0 == null) {
                                val.zt = "报告生成中";
                            }
                            if (val.Status == 0 && val.cgzbgStatus == 2 && val.ccstatus_0 == null) {
                                val.zt = "报告生成失败";
                            }
                            if (val.Status == 0 && val.cgzbgStatus == 1 && val.ccstatus_0 !== null) {
                                val.zt = "查重中";
                            }
                        }


                        // if (
                        //   (val.Status == 0 &&
                        //     val.cgzbgStatus == 1 &&
                        //     val.ccstatus === null) ||
                        //   (val.Status == 0 && val.cgzbgStatus == 1 && val.ccstatus === 1)
                        // ) {
                        //   val.zt = "报告生成中";
                        // }
                    });
                })
                .catch(function () { });
        },
        delRepot(id) {
            this.$confirm("确认删除后，成果内容无法复原，是否确认继续操作?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$axios
                        .post(
                            "report/del",
                            this.$qs.stringify({
                                ReportId: id,
                                token: sessionStorage.getItem("token"),
                            })
                        )
                        .then((res) => {
                            console.log(res);
                            if (res.data.code == 10000) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                this.getlist();
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.data.msg,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        getJd(id) {
            let that = this;
            // console.log(row)
            for (let key in that.end) {
                that.end[key] = "";
            }
            this.$axios
                .post(
                    "flow/flowtimeline",
                    this.$qs.stringify({
                        ReportID: id,
                        token: sessionStorage.getItem("token"),
                    })
                )
                .then((res) => {
                    console.log(res.data.data);
                    that.jindu = [];
                    if (res.data.code == 10000) {
                        that.jindu = res.data.data;
                        if (this.jindu.length > 0) {
                            this.dialogVisible = true;
                            console.log(this.jindu);
                            that.useRsubmit.time = this.jindu[0].datetime;
                            that.useRsubmit.zt = "已提交";
                            that.jindu.forEach(function (val, index) {
                                // if(val.operation==)
                                console.log(val);
                                switch (val.operation) {
                                    case "1":
                                        val.zt = "待审核";
                                        break;
                                    case "2":
                                        val.zt = "审核通过";
                                        break;
                                    case "3":
                                        val.zt = "审核未通过";
                                        break;
                                    case "4":
                                        val.zt = "待评分";
                                        break;
                                }
                                that.jindu[0].companyName = "";
                                that.jindu[0].zt = "已提交";
                                if (val.companyName == val.nextcompanyName && val.operation == 1) {
                                    val.zt = "提交成果";
                                    val.companyName = "";
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg == "审核通过！" && val.operator != 1) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (
                                    index == that.jindu.length - 1 &&
                                    val.sysmsg == "审核通过！" &&
                                    val.operator == 1 &&
                                    val.companyName != "中国煤炭工业协会"
                                ) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待评分";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.companyName == "") {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (
                                    index == that.jindu.length - 1 &&
                                    val.operation == 3 &&
                                    val.companyID != val.nextcompanyID
                                ) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg === null && val.operation != 1) {
                                    for (let key in that.end) {
                                        that.end[key] = "";
                                    }
                                }

                                if (val.sysmsg == "审核通过！" && val.companyName == "中国煤炭工业协会") {
                                    that.jindu = that.jindu.slice(0, index + 1);
                                    that.jindu[that.jindu.length - 1].zt = "";
                                }
                                if (that.jindu.length == 0) {
                                    that.active = 1;
                                } else {
                                    that.active = that.jindu.length;
                                }
                            });
                            // this.jindu.forEach(val => {
                            // if(val.operation==1){
                            //   val.operation="审核通过"
                            // }eli
                            // switch (val.operation) {
                            //   case "1":
                            //     val.operation = "待审核";
                            //     break;
                            //   case "2":
                            //     val.operation = "审核通过";
                            //     break;
                            //   case "3":
                            //     val.operation = "审核未通过";
                            //     break;
                            // }
                            // });
                        } else {
                            this.$message({
                                type: "warning",
                                message: "暂无进度信息",
                            });
                        }
                    } else if (res.data.code == 10002) {
                        this.$message({
                            type: "warning",
                            message: res.data.msg,
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
        },
        watch(comment) {
            this.showIdea = !this.showIdea;
            this.useRsubmit.comment = comment;
        },
        bianse(i, column) {
            this.i = i;
            console.log(column);
            switch (column) {
                case "主报告":
                    this.j = i;
                    this.i = false;
                    break;
                // case "附件":
                // this.a=i;
                // this.i=false;
                // break;
                case "预览":
                    this.ylW = i;
                    this.i = false;
                    break;
            }
        },
        hy(i) {
            this.i = false;
            this.j = false;
            this.ylW = false;
            console.log(i);
        },
        // cancelW() {
        //   this.ylW = false;
        // },
        ylWord(i, cbg, val) {
            let that = this;
            if (i == "无") {
                this.$message("暂无主报告信息");
                return;
            }
            console.log(cbg);
            if (val == 0) {
                that.showReport = true;
                // that.zt = 2;
                that.zbg = cbg;
                console.log(cbg);
            } else {
                that.$axios
                    .post("word/words?ReportID=" + cbg + "&token=" + sessionStorage.getItem("token"))
                    .then(function (res) {
                        console.log(res);
                        window.location.href = res.data.data;
                    })
                    .catch(function () { });
                this.$message({
                    showClose: true,
                    message: "仅支持office2010以上的版本打开",
                });
            }
        },
        // isLink(row) {
        //   if (!row.Link) {
        //     return "无";
        //   } else {
        //     return "有";
        //   }
        // },
        // isStatus(row) {
        //   let Status = row.Status;
        //   console.log(Status);
        //   let text = "";
        //   switch (Status) {
        //     case "0":
        //       text = "未提交";
        //       break;
        //     case "1":
        //       text = "待审核";
        //       break;
        //     case "2":
        //       text = "审核通过";
        //       break;
        //     case "3":
        //       text = "已拒绝";
        //       break;
        //     case "4":
        //       text = "待评审";
        //       break;
        //     case "5":
        //       text = "完成";
        //       break;
        //     case "6":
        //       text = "结束";
        //       break;
        //   }
        //   return text;
        // },

        deleteRow(row) {
            console.log(row);
            sessionStorage.setItem("reportID", row.ID);
            sessionStorage.setItem("isListGo", true);
            let routeUrl = this.$router.resolve({
                path: "/Preview",
                query: { table: row },
            });
            window.open(routeUrl.href, "_blank");
        },
        preview(i, j, val) {
            let that = this;
            console.log(val);
            if (j == "0%") {
                that.$message("暂无信息");
                return;
            }
            let ReportID = that.tableData[i].id;

            if (val == 1) {
                console.log(ReportID);
                that.$axios
                    .post("word/sbb?ReportID=" + ReportID + "&token=" + sessionStorage.getItem("token"))
                    .then(function (res) {
                        console.log(res);
                        window.location.href = res.data.data;
                    })
                    .catch(function () { });
                this.$message({
                    showClose: true,
                    message: "仅支持office2010以上的版本打开",
                });
            } else {
                that.$axios
                    .post(
                        "reportcontent/info?token=" + sessionStorage.getItem("token"),
                        that.$qs.stringify({
                            ReportID,
                        })
                    )
                    .then((res) => {
                        if (res.data.code == 10000) {
                            //获取报告信息
                            console.log(res.data.data);
                            that.yulan = JSON.stringify(res.data.data);
                            this.sbbYear = res.data.year;
                            that.show = true;
                            that.zt = 1;
                        } else if (res.data.code == 10002) {
                            this.$message({
                                type: "warning",
                                message: res.data.msg,
                            });
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
            }
        },
        showP(i) {
            if (i == 0) {
                this.show = false;
            } else {
                this.showReport = false;
            }
        },
        flexColumnWidth(str) {
            let flexWidth = 0;
            for (const char of str) {
                if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
                    // 如果是英文字符，为字符分配8个单位宽度
                    flexWidth += 8;
                } else if (char >= "\u4e00" && char <= "\u9fa5") {
                    // 如果是中文字符，为字符分配20个单位宽度
                    flexWidth += 30;
                } else {
                    // 其他种类字符，为字符分配5个单位宽度
                    flexWidth += 5;
                }
            }
            if (flexWidth < 50) {
                // 设置最小宽度
                flexWidth = 200;
            }
            if (flexWidth > 250) {
                // 设置最大宽度
                flexWidth = 250;
            }
            return flexWidth + "px";
        },
        submit(i, j) {
            var that = this;
            console.log(i, j);
            if (j.row.fj == "无") {
                this.$message.warning("请上传附件");
                return;
            }
            this.$confirm("确认提交吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // 提交主报告
                    that.$axios
                        .post(
                            // that.$URL +"/report/reportover?ReportID=" +that.ReportID +"&token=" +sessionStorage.getItem("token")
                            "report/reportover",
                            that.$qs.stringify({
                                ReportID: j.row.id,
                                token: sessionStorage.getItem("token"),
                            })
                        )
                        .then((res) => {
                            if (res.data.code == 10001) {
                                this.$alert(`${res.data.msg}`, "", {
                                    confirmButtonText: "确定",
                                    callback: () => {
                                        window.location.reload();
                                    },
                                });
                            } else {
                                that.loading = true;
                                that.$message({ message: "报告生成中请耐心等待!" });
                                that.$axios.post(
                                    "message/updatestatus",
                                    that.$qs.stringify({
                                        ReportID: j.row.id,
                                        type: 1,
                                        token: sessionStorage.getItem("token"),
                                    })
                                );
                                window.location.reload();
                            }
                        });

                    // window.location.reload();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消修改",
                    });
                });
        },
        modification(i, id) {
            console.log(i, "i");
            console.log(id, "id");
            this.$router.push({ path: "/Surface", query: { ReportID: id } });
        },
    },
    components: {
        Head,
        Foot,
        decLeftNav,
        Preview,
        FullPreview,
        RightNav,
    },
};
</script>
<style lang="less">
.el-dropdown {
    display: none;
}

@media screen and (max-width: 1800px) {
    .el-dropdown {
        display: block;
    }

    .btns {
        display: none !important;
    }

    .el-table__row td:last-child {
        .cell {
            padding-left: 0px;

            .el-button {
                font-size: 12px;
            }
        }
    }

    .el-dropdown-menu {
        li {
            padding: 0;

            span {
                display: inline-block;
                padding: 0 20px;
                width: 100%;
                height: 100%;
            }
        }

        li:hover {
            color: #fff !important;
        }

        li:first-of-type:hover {
            background: #66b1ff;
        }

        li:nth-of-type(2):hover {
            background: #67c23a;
        }

        li:last-of-type:hover {
            background: #f56c6c;
        }
    }
}

.active {
    color: #409eff;
    cursor: pointer;
}

.el-loading-spinner i,
.el-loading-spinner .el-loading-text {
    color: #fff !important;
}

// 步骤条
.el-dialog {
    .el-dialog__title {
        font-size: 0.4rem;
        font-weight: 500;
    }

    .el-step__head.is-process {
        color: #c0c4cc;
        border-color: #c0c4cc;
    }

    .el-step__title.is-finish {
        color: #303133;
    }

    .el-step__title.is-process {
        font-weight: normal;
    }

    .el-step__description.is-finish {
        color: #303133;

        .content {
            display: flex;
            margin-bottom: .2rem;

            .opinion {
                text-indent: 2em;
            }


            .contentMsg {
                position: relative;
                padding-left: 10px;
            }

            .contentMsg ::before {
                content: "";
                background-color: #3796EC;
                width: 3px;
                height: .45rem;
                position: absolute;
                left: 0;
                top: 10%;
                // margin-top: -9px;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;
            }
        }

        p {
            width: 1.6rem;
            height: 0.5rem;
        }

        // div {
        //   width: 1.2rem;
        //   height: 0.4rem;
        //   line-height: 0.4rem;
        //   text-align: center;
        //   color: #fff;
        //   background: #2d65d2;
        //   margin: 0 auto;
        //   margin-top: 0.1rem;
        //   cursor: pointer;
        // }
    }

    .watch {
        margin-top: 0.3rem;
        border-top: 1px solid #aaa;
        padding-top: 0.16rem;
        color: #333;

        p {
            font-size: 0.18rem;
            margin-bottom: 0.16rem;
            font-weight: bold;
        }

        div {
            text-indent: 2em;
            line-height: 2;
        }
    }
}
</style>
<style lang="less" scoped>
#tableList {
    width: 100%;
    min-width: 1000px;

    .tablelist {
        margin-top: 0.4rem;
        width: 100%;
        padding: 0 1.35rem;
        font-size: 0.18rem;
        display: flex;
        align-items: stretch;

        .leftNav {
            padding-right: 0.4rem;
            border-right: 0.01rem solid #e4e4e4;
        }

        .Main {
            position: relative;
            width: 13.5rem;
            height: 12rem;
            overflow: hidden;
            margin-left: 0.5rem;
            padding: 0.15rem;
            display: flex;
            flex-flow: column;

            .el-select {
                width: 1.5rem;
                margin-bottom: 0.2rem;
            }

            .btns {
                display: flex;
                flex-wrap: wrap;

                // .btn {
                //   width: 0.6rem;
                //   height: 0.35rem;
                //   line-height: 0.35rem;
                //   background: #35b018;
                //   border-radius: 0.03rem;
                //   margin: 0 auto;
                //   color: #fff;
                //   cursor: pointer;
                // }
                // .btn:nth-of-type(1) {
                //   margin-bottom: 0.1rem;
                //   background: #409eff;
                // }
                // .bnt:nth-last-of-type(3){
                //   background: rgb(251, 23, 82);
                // }
            }

            .ylW {
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.6);
                position: absolute;
                left: 0;
                top: 0;

                .iframe {
                    width: 90%;
                    margin: 0.5rem 0 0.3rem 0.6rem;
                }

                img {
                    width: 0.3rem;
                    height: 0.3rem;
                    position: absolute;
                    right: 0.25rem;
                    top: 0.25rem;
                }
            }

            .preview {
                width: 100%;
                background: rgba(0, 0, 0, 0.5);
                // background: #7f7f7f;
                position: relative;

                // position: absolute;
                // top: 0;
                // z-index: 1;
                .in {
                    width: 90%;
                    height: 10.5rem;
                    margin: 0 auto;
                    margin-top: 0.6rem;
                    background: #fff;
                    overflow: auto;

                    img {
                        width: 0.4rem;
                        height: 0.4rem;
                        position: absolute;
                        cursor: pointer;
                        right: 0.2rem;
                        top: 0.2rem;
                    }
                }
            }
        }
    }
}
</style>
